export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11545.41d5ad81.jpg";